import get from 'lodash/get'
import isString from 'lodash/isString'

export const displayError = (err: unknown): string => {
  let message = ''

  message = get(err, 'data.error.message')
  if (message && isString(message)) return message

  message = get(err, 'data.message')
  if (message && isString(message)) return message

  message = get(err, 'data.error')
  if (message && isString(message)) return message

  message = get(err, 'message')
  if (message && isString(message)) return message

  return 'Something went wrong. Unknown error.'
}
